"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
var _encryption = _interopRequireDefault(require("../encryption"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Card = exports["default"] = /*#__PURE__*/function (_Core) {
  function Card(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Card);
    _this = _callSuper(this, Card, [props]);
    _this.connection = props.connection;
    _this.appName = props.appName;
    _this.on = _this.on.bind(_this);
    _this._events = {};
    _this.init();
    _this.cryptoKey = props.cryptoKey;
    _this.publicKey = props.publicKey;
    _this.services = props.services;
    _this.ready = false;
    _this.myServices = ["crs"];
    return _this;
  }
  (0, _inherits2["default"])(Card, _Core);
  return (0, _createClass2["default"])(Card, [{
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "getCheckReady",
    value: function () {
      var _getCheckReady = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this3 = this;
        var payload, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              payload = {
                action: "System.CardReader.CheckReady",
                uuid: (0, _uuid.v4)(),
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                request_uuid: "",
                data: "{}"
              };
              _context.next = 1;
              return this.connection.invoke("messaging", payload);
            case 1:
              return _context.abrupt("return", new Promise(function (resolve, reject) {
                _this3.connection.on("messaging", function (msg) {
                  if (msg.action === "System.CardReader.Notify.Ready") {
                    if (!_this3.ready) {
                      _this3.ready = true;
                      _this3.trigger("ready", true);
                      _logger["default"].success("Initialization done", "Module is now ready", "Card");
                      resolve();
                    }
                  }
                });
              }));
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error("Error in getCheckReady:", _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getCheckReady() {
        return _getCheckReady.apply(this, arguments);
      }
      return getCheckReady;
    }()
  }, {
    key: "writeCard",
    value: function writeCard(cardData) {
      var payload = {
        action: "System.CardReader.CardWrite",
        uuid: (0, _uuid.v4)(),
        origin: "sdk-" + this.appName,
        timestamp: Number(BigInt(Date.now()) * 1000000n),
        request_uuid: "",
        data: cardData
      };
      this.connection.invoke("messaging", payload)["catch"](function (error) {
        console.error("Error writing card:", error);
      });
    }
  }, {
    key: "cardReaderStart",
    value: function () {
      var _cardReaderStart = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var _this4 = this;
        var uuid, origin, timestamp, payload, _t3;
        return _regenerator["default"].wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context3.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: "System.PeripheralsManager.CardReaderStart",
                params: "{}"
              }, uuid, origin, timestamp);
            case 1:
              payload = _context3.sent;
              _context3.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                _this4.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(msg) {
                    var decryptedData, jsonObject, _t2;
                    return _regenerator["default"].wrap(function (_context2) {
                      while (1) switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(msg.action === 'System.SDK.ServiceCall')) {
                            _context2.next = 4;
                            break;
                          }
                          _context2.prev = 1;
                          _context2.next = 2;
                          return _encryption["default"].decryptSymmetrically(_this4.services["dpm"], msg.data);
                        case 2:
                          decryptedData = _context2.sent;
                          jsonObject = JSON.parse(decryptedData);
                          if (jsonObject.command === 'System.PeripheralsManager.CardReaderStart.Response') {
                            resolve(jsonObject.params);
                          }
                          _context2.next = 4;
                          break;
                        case 3:
                          _context2.prev = 3;
                          _t2 = _context2["catch"](1);
                          reject(_t2); // Properly handle decryption and parsing errors
                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }, _callee2, null, [[1, 3]]);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](0);
              console.error("Error sending start card reader message:", _t3);
              throw _t3;
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function cardReaderStart() {
        return _cardReaderStart.apply(this, arguments);
      }
      return cardReaderStart;
    }()
  }, {
    key: "cardReaderStop",
    value: function () {
      var _cardReaderStop = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var _this5 = this;
        var uuid, origin, timestamp, payload, _t5;
        return _regenerator["default"].wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              uuid = (0, _uuid.v4)();
              origin = "sdk-" + this.appName;
              timestamp = Number(BigInt(Date.now()) * 1000000n);
              _context5.next = 1;
              return _encryption["default"].generateSymmetricallyEncryptedPayload(this.services["dpm"], {
                command: "System.PeripheralsManager.CardReaderStop",
                params: "{}"
              }, uuid, origin, timestamp);
            case 1:
              payload = _context5.sent;
              _context5.next = 2;
              return this.connection.invoke("messaging", payload);
            case 2:
              return _context5.abrupt("return", new Promise(function (resolve, reject) {
                _this5.connection.on("messaging", /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(msg) {
                    var decryptedData, jsonObject, _t4;
                    return _regenerator["default"].wrap(function (_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!(msg.action === 'System.SDK.ServiceCall')) {
                            _context4.next = 4;
                            break;
                          }
                          _context4.prev = 1;
                          _context4.next = 2;
                          return _encryption["default"].decryptSymmetrically(_this5.services["dpm"], msg.data);
                        case 2:
                          decryptedData = _context4.sent;
                          jsonObject = JSON.parse(decryptedData);
                          if (jsonObject.command === 'System.PeripheralsManager.CardReaderStop.Response') {
                            resolve(jsonObject.params);
                          }
                          _context4.next = 4;
                          break;
                        case 3:
                          _context4.prev = 3;
                          _t4 = _context4["catch"](1);
                          reject(_t4); // Properly handle decryption and parsing errors
                        case 4:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4, null, [[1, 3]]);
                  }));
                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              }));
            case 3:
              _context5.prev = 3;
              _t5 = _context5["catch"](0);
              console.error("Error sending stop card reader message:", _t5);
              throw _t5;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 3]]);
      }));
      function cardReaderStop() {
        return _cardReaderStop.apply(this, arguments);
      }
      return cardReaderStop;
    }()
  }, {
    key: "mockCardRead",
    value: function mockCardRead() {
      var _this6 = this;
      return new Promise(function (resolve, reject) {
        var payload = {
          action: "System.CardReader.FakeReadEvent",
          uuid: (0, _uuid.v4)(),
          origin: "sdk-" + _this6.appName,
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          request_uuid: "",
          data: "{}"
        };
        _this6.connection.invoke("messaging", payload).then(function () {
          _this6.connection.on("messaging", function (msg) {
            if (msg.action === "System.CardReader.CardRead") {
              resolve();
            }
          });
        });
      });
    }
  }, {
    key: "handleMessages",
    value: function () {
      var _handleMessages = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(message) {
        var notification, data, data_read, data_write, requestData, _t6;
        return _regenerator["default"].wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context6.next = 1;
                break;
              }
              return _context6.abrupt("return");
            case 1:
              _t6 = message.action;
              _context6.next = _t6 === 'System.CardReader.CardRead' ? 2 : _t6 === 'System.CardReader.CardRemoved' ? 3 : _t6 === 'System.CardReader.CardWrite.Response' ? 4 : _t6 === 'System.SDK.ServiceNotification.Response' ? 5 : _t6 === 'System.ServiceNotification' ? 7 : 10;
              break;
            case 2:
              data_read = JSON.parse(message.data);
              this.trigger("cardRead", data_read);
              return _context6.abrupt("return");
            case 3:
              notification = JSON.parse(message.data);
              this.trigger("cardOut", notification);
              return _context6.abrupt("return");
            case 4:
              data_write = JSON.parse(message.data);
              this.trigger("cardWrite", data_write);
              return _context6.abrupt("return");
            case 5:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context6.next = 6;
                break;
              }
              return _context6.abrupt("return");
            case 6:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              return _context6.abrupt("return");
            case 7:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context6.next = 8;
                break;
              }
              return _context6.abrupt("return");
            case 8:
              // Send our data
              requestData = typeof message.data === "string" ? JSON.parse(message.data) : message.data;
              _context6.next = 9;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(requestData.serviceIdentification, ".ServiceNotification.Response"),
                origin: "sdk-" + this.appName,
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 9:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context6.abrupt("return");
            case 10:
              return _context6.abrupt("continue", 11);
            case 11:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function handleMessages(_x3) {
        return _handleMessages.apply(this, arguments);
      }
      return handleMessages;
    }()
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Card");
      var foundServices = this.detectServices();
      if (!foundServices) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Card");
      } else {
        this.ready = true;
        this.trigger("ready", true);
        this.connection.on("messaging", this.handleMessage.bind(this));
      }
      this.getCheckReady();
      _logger["default"].info("Check ready", "Checking if everything is ready", "Card");
      this.connection.on("messaging", this.handleMessages.bind(this)); //i get error here like on is not defined when called from encryption.js
    }
  }]);
}(_core["default"]);